import { data, Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function TrialTranscriptionModal({ setShowModal }) {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [contact, setContact] = useState('');
    const [file, setFile] = useState(null);
    // const [error, setError] = useState({});
    const [fileError, setFileError] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const [loading, setLoading] = useState(false);

    const handleFileChange = (e) => {

        const selectedFile = e.target.files[0];
        if (!selectedFile) return;

        // Validate file type by MIME type and extension
        const isWav =
            selectedFile.type === 'audio/wav' ||
            selectedFile.name.toLowerCase().endsWith('.wav');

        if (!isWav) {
            setFileError('Please upload a valid .wav audio file.');
            setFile(null);
            return;
        }

        setFileError('');

        setFile(e.target.files[0]); // Get the first selected file

        e.preventDefault()
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // const newErrors = {};
        // if (!email.trim()) newErrors.email = 'Email is required';
        // if (!contact.trim()) newErrors.contact = 'Mobile No. is required';

        // setError(newErrors);

        if (!file) {

            setFileError('No valid file selected.');
            return;
        }

        setLoading(true);

        // Prepare form data
        const formData = new FormData();
        // formData.append('email', document.getElementById('floatingInputEmail').value);
        // formData.append('mobile', document.getElementById('floatingMobileNumber').value);
        formData.append('AudioFile', file);

        // Simulate upload (replace with your API endpoint)
        fetch(process.env.REACT_APP_DECIPHERX_API_URL + '/Trial/TrialTranscription', {
            method: 'POST',
            body: formData,
            credentials: 'include',
        })
            .then(
                (res) => {
                    if (res.status === 401)
                        navigate('/Login');
                    else if (res.ok) {
                        res.json().then(data => {
                            const responseData = data;
                            console.log('Response:', responseData);
                            setSubmitted(true);
                        });
                    }
                    else
                        throw new Error('Network response was not ok');
                }
            )
            // .then((data) => {
            //     console.log('Upload success:', data);
            // })
            .catch((err) => {
                console.error('Upload error:', err);
                Swal.fire({
                    title: "Error",
                    text: "Error occurred while transcription, Please try again.",
                    icon: "error"
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };


    return (
        <div className="modal d-block fade show bg-body-secondary p-4 py-md-5 custom-modal-backdrop" tabIndex="-1" role="dialog" id="demoModal" data-bs-backdrop="static" data-bs-keyboard="false" data-bs-focus="false" aria-labelledby="demoModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content rounded-4 shadow">
                    <div className="modal-header p-5 pb-4 border-bottom-0">
                        <h1 className="fw-bold mb-0 fs-2" id="demoModalLable">Transcription Demo</h1>
                        <button type="button" className="btn-close" onClick={() => setShowModal(false)} aria-label="Close"></button>
                    </div>

                    <div className="modal-body p-5 pt-0">
                        {submitted ? (
                            <div className="text-center">
                                <h4 className="text-success mb-3">File Uploaded Successfully!</h4>
                                <p>The transcription will be sent to your registered email address shortly.</p>
                                <p className="text-muted">Please allow up to <strong>15–30 minutes</strong> depending on file length.</p>
                                <button className="btn btn-outline-secondary mt-3" onClick={() => setShowModal(false)}>Close</button>
                            </div>
                        ) : (

                            <form onSubmit={handleSubmit}>
                                {/* <div className="form-floating mb-3">
                                            <input type="email" className="form-control rounded-3" id="floatingInputEmail" placeholder="name@example.com" onChange={(e) => setEmail(e.target.value)} />
                                            <label htmlFor="floatingInputEmail">Email address</label>
                                            {error.email && <div className="text-danger mt-2">{error.email}</div>}
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input type="text" className="form-control rounded-3" id="floatingMobileNumber" placeholder="Mobile Number (e.g. +91-0000000000)" onChange={(e) => setContact(e.target.value)} />
                                            <label htmlFor="floatingMobileNumber">Mobile No. (e.g. +91-000 000 0000)</label>
                                            {error.contact && <div className="text-danger mt-2">{error.contact}</div>}
                                        </div> */}

                                <div className="mb-3">
                                    <label htmlFor="formFile" className="form-label"></label>
                                    <input className="form-control" type="file" id="formFile" accept=".wav,audio/wav" onChange={handleFileChange} />
                                    {fileError && <div className="text-danger mt-2">{fileError}</div>}
                                </div>

                                <button className="w-100 mb-2 btn btn-lg rounded-3 btn-primary" type="submit" disabled={!file || loading}>

                                    {!loading ? "Transcribe Audio" : (
                                        <>
                                            <span className="dot dot1 mx-2 text-center"></span>
                                            <span className="dot dot2 mx-2"></span>
                                            <span className="dot dot3 mx-2"></span>
                                        </>
                                    )}
                                </button>
                                <small className="text-body-secondary">By clicking Transcribe Audio, you agree to the terms of use.</small>
                                <hr className="my-4" />
                                <small className="text-body-secondary">Audio transcription will be sent to you on the registered email.</small>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TrialTranscriptionModal; 